/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

import * as CollapsiblePrimitive from "@radix-ui/react-collapsible"

const Collapsible = CollapsiblePrimitive.Root

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent

export { Collapsible, CollapsibleTrigger, CollapsibleContent }
